import { useSearchParams } from "react-router-dom";
import { PET_VIEW_USER_PARAM } from "../../../enums/UrlPaths";

// Owner (user) id of the pet in the single pet view, taken from ?user=.
// Null for clinic-owned pets.
export default function usePetViewOwnerId() {
  const [searchParams] = useSearchParams();
  return searchParams.get(PET_VIEW_USER_PARAM);
}
